import { useT } from '../../i18n';
import { useOnline } from '../../sync';
import { cx } from './lib/classNames';
import styles from './OfflineBanner.module.css';

export interface OfflineBannerProps {
  className?: string;
}

export function OfflineBanner({ className }: OfflineBannerProps) {
  const online = useOnline();
  const { t } = useT();

  if (online) return null;

  return (
    <div className={cx(styles.root, className)} role="status">
      {t('pwa.offline')}
    </div>
  );
}
